import React, { useRef, useState } from 'react';
import { UploadCloud } from 'lucide-react';
interface LabelUploadEmptyStateProps {
  note: string;
  onBackClick?: () => void;
}
export function LabelUploadEmptyState({
  note,
  onBackClick
}: LabelUploadEmptyStateProps) {
  const [fileName, setFileName] = useState<string | null>(null);
  const inputRef = useRef<HTMLInputElement>(null);
  return <div className="space-y-6" data-id="element-960" data-mp="1j1xf6rwgxlxj">
      <section className="mx-auto w-full max-w-2xl rounded-2xl border border-[#dce3da] bg-white p-6 text-center shadow-sm" data-id="element-961" data-mp="14ay85lba75g2">
        <h2 className="font-[Figtree] text-xl font-semibold text-evergreen" data-id="element-962" data-mp="192q122hwtn9d">Upload label artwork</h2>
        <p className="mx-auto mt-1 max-w-md text-sm leading-relaxed text-[#6b7d70]" data-id="element-963" data-mp="vbtdiq2ubw96">
          Send 1 to 8 faces (front, back, sides). Multi-face is one call and counts as a single analysis.
        </p>

        <div className="mt-5 flex flex-col items-center gap-3 rounded-2xl border-2 border-dashed border-[#cfdacc] bg-[#f8faf6] px-6 py-9" data-id="element-964" data-mp="lcvo7kxlbyp4">
          <span className="flex h-12 w-12 items-center justify-center rounded-full bg-white text-forest-green ring-1 ring-[#dbe4d8]" data-id="element-965" data-mp="1g8iv6ahusob4">
            <UploadCloud className="h-5 w-5" data-id="element-966" data-mp="1b8d16no42ppv" />
          </span>
          <h3 className="font-[Figtree] text-base font-semibold text-evergreen" data-id="element-967" data-mp="1p979z7f2msp2">Upload label artwork</h3>
          <p className="text-xs text-[#8b968d]" data-id="element-968" data-mp="1l7viewcmzxe8">Accepted: JPEG, PNG, WebP, PDF · Max size: 10 MB per file</p>
          <button type="button" onClick={() => inputRef.current?.click()} className="mt-1 rounded-xl border border-[#d6dfd3] bg-white px-4 py-2.5 text-sm font-semibold text-evergreen transition hover:bg-[#f2f6f0]" data-id="element-969" data-mp="xhi03xjutcwu">
            Pick from library
          </button>
          <p className="font-mono text-[10px] font-semibold uppercase tracking-[0.15em] text-[#9aa79c]" data-id="element-970" data-mp="11jcz2vebbe7g">Up to 8 files</p>
          {fileName && <p className="text-xs font-semibold text-forest-green" data-id="element-971" data-mp="dsh9m4xbwv3d">{fileName}</p>}
          <input ref={inputRef} type="file" className="hidden" onChange={event => {
          const file = event.target.files?.[0];
          if (file) setFileName(file.name);
          event.target.value = '';
        }} data-id="element-972" data-mp="9rdujkn3v337" />
        </div>
      </section>

      <p className="mx-auto max-w-2xl text-center text-sm text-[#8b968d]" data-id="element-973" data-mp="2ins3kezbvncr">{note}</p>

      <div className="flex flex-col items-center gap-3" data-id="element-974" data-mp="2nljxfejj9jjl">
        <button type="button" disabled={!fileName} className="rounded-xl bg-evergreen px-5 py-3 text-sm font-semibold text-white transition enabled:hover:bg-forest-green disabled:cursor-not-allowed disabled:bg-[#dbe2d8] disabled:text-[#9aa79c]" data-id="element-975" data-mp="1pyuo0jmi44np">
          Analyze packaging
        </button>
        <button type="button" onClick={onBackClick} className="text-sm font-semibold text-[#637667] transition hover:text-forest-green hover:underline" data-id="element-976" data-mp="24wdatgfmc7si">
          Back to dashboard
        </button>
      </div>
    </div>;
}